export default __webpack_public_path__ + "static/media/requisitos_adopcion_responsable.1064f6f1.pdf";